import { FLOOR_PLANS_LAYOUT } from '../constants';

export const FloorDetail = ({ selectedBuilding, selectedSegment }) => {
  const { totalApartments, totalElevators } =
    FLOOR_PLANS_LAYOUT[selectedBuilding];
  return (
    <div className="floor-detail-card">
      <div className="card-content">
        <div className="card-header">
          <p className="title">Floor plan {selectedBuilding.toUpperCase()}</p>
          {/* <p className="description">Tầng 6-22</p> */}
        </div>
        <div className="card-body">
          <div className="body-item">
            <span className="title">Number of apartments</span>
            <span className="number">{totalApartments}</span>
          </div>
          <div className="body-item">
            <span className="title">Number of elevators</span>
            <span className="number">{totalElevators}</span>
          </div>
          {/* <div
            className="map"
            style={{
              transform: selectedBuilding === 'vic-1' && 'scale(1, -1)',
            }}
          >
            <img
              src={mini}
              alt={`Building floor plan of ${selectedBuilding}-${selectedSegment}`}
            />
          </div> */}
        </div>
      </div>
    </div>
  );
};
